<template>
  <footer :class="`footer footer-${currentPageName}`">
    <div class="container">
      <div class="row">
        <div class="col-md-8 col-12 mx-auto">
          <div class="row">
            <div class="col-md-3 col-3 mx-auto mb-0 px-0 text-wrapper-13 cursor_pointer" @click="redirect('/about')">
              {{ $t('footer.about') }}
            </div>
            <!-- <div class="col-md-3 col-3 mx-auto mb-0 px-0 text-wrapper-13 cursor_pointer"
              @click="redirect('/investors')">
              {{ $t('footer.investors') }}
            </div> -->
            <!-- 
            <div class="col-md-3 col-3 mx-auto mb-0 px-0 text-wrapper-13 cursor_pointer" @click="redirect('/register')">
              List Your Company
            </div> 
            -->
            <div class="col-md-3 col-3 mx-auto mb-0 px-0 text-wrapper-13 cursor_pointer"
              @click="redirect('/privacy-policy')">
              {{ $t('footer.privacy') }}
            </div>
            <!-- 
            <div class="col-md-3 col-3 mx-auto mb-0 px-0 text-wrapper-14 cursor_pointer"
              @click="$emit('clickToSettings')">
              Settings
            </div> 
            -->
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'FooterCompanent',
  data() {
    return {
      showFooterMenu: false,
    }
  },
  methods: {
    redirect(link) {
      this.$router.push(link);
      this.click_to_footer('Footer Navigation', link);
    },
    click_to_footer(label, link) {
      if (this.$ga) {
        this.$ga.event('Click to footer', label, link, window.location.href);
      }
    },
  },
  computed: {
    currentPageName() {
      return this.$route.name || 'Index';
    }
  }
}
</script>

<style scoped>
/* .footer {
  width: 100%;
  * height: 69px; *
  height: 45px;
  * padding-top: 22px; *
  padding-top: 12px;
  * position: fixed; *
  * position: relative; *
  * bottom: 0; *
  background-color: #e6eeff;
  z-index: 1000;
} */

.footer {
  min-height: 40px;
  max-height: 110px;
  width: 100%;
  z-index: 3;
  position: fixed;
  bottom: 0;
  flex: 0 0 auto;
  /* overflow-x: auto; */
  background-color: #F2F5F5;
  padding: 10px;
}

/* @media (max-width: 992px) {
  .footer {
    height: 75px;
    padding-top: 18px;
  }
} */

/* @media (max-width: 576px) {
  .footer {
    height: 75px;
    padding-top: 15px;
  }
} */

.footer-IndexPage,
.footer-JobSeekerProfile {
  position: fixed;
  bottom: 0;
}

.footer .div {
  cursor: pointer;
}

.text-wrapper-13 {
  position: relative;
  font-family: "Inter", Helvetica;
  font-weight: 400;
  color: #272626;
  font-size: 12px;
  text-align: center;
  letter-spacing: 0;
  line-height: normal;
}

.how-search-works {
  position: relative;
  font-family: "Inter", Helvetica;
  font-weight: 400;
  color: #272626;
  font-size: 13px;
  text-align: center;
  letter-spacing: 0;
  line-height: normal;
}

.privacy-policy {
  position: relative;
  font-family: "Inter", Helvetica;
  font-weight: 400;
  color: #272626;
  font-size: 13px;
  text-align: center;
  letter-spacing: 0;
  line-height: normal;
}

.terms-of-service {
  position: relative;
  font-family: "Inter", Helvetica;
  font-weight: 400;
  color: #272626;
  font-size: 13px;
  text-align: center;
  letter-spacing: 0;
  line-height: normal;
}

.text-wrapper-14 {
  position: relative;
  font-family: "Inter", Helvetica;
  font-weight: 400;
  color: #272626;
  font-size: 13px;
  text-align: center;
  letter-spacing: 0;
  line-height: normal;
}
</style>